import { render, staticRenderFns } from "./Ouch.vue?vue&type=template&id=b341cb9a&scoped=true&"
import script from "./Ouch.vue?vue&type=script&lang=js&"
export * from "./Ouch.vue?vue&type=script&lang=js&"
import style0 from "./Ouch.vue?vue&type=style&index=0&id=b341cb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b341cb9a",
  null
  
)

component.options.__file = "Ouch.vue"
export default component.exports